import { r as registerInstance, h, H as Host } from './index-506c059e.js';
import { c as classNames } from './index-f9dffc47.js';

const ALL_COLORS = [
    'bp-primary-yellow50',
    'bp-primary-yellow100',
    'bp-primary-yellow200',
    'bp-primary-yellow300',
    'bp-primary-yellow400',
    'bp-primary-yellow500',
    'bp-primary-yellow600',
    'bp-primary-yellow700',
    'bp-primary-yellow800',
    'bp-primary-yellow900',
    'bp-primary-blue50',
    'bp-primary-blue100',
    'bp-primary-blue200',
    'bp-primary-blue300',
    'bp-primary-blue400',
    'bp-primary-blue500',
    'bp-primary-blue600',
    'bp-primary-blue700',
    'bp-primary-blue800',
    'bp-primary-blue900',
    'bp-secondary-yellowGold50',
    'bp-secondary-yellowGold100',
    'bp-secondary-yellowGold200',
    'bp-secondary-yellowGold300',
    'bp-secondary-yellowGold400',
    'bp-secondary-yellowGold500',
    'bp-secondary-yellowGold600',
    'bp-secondary-yellowGold700',
    'bp-secondary-yellowGold800',
    'bp-secondary-yellowGold900',
    'bp-secondary-darkCyan50',
    'bp-secondary-darkCyan100',
    'bp-secondary-darkCyan200',
    'bp-secondary-darkCyan300',
    'bp-secondary-darkCyan400',
    'bp-secondary-darkCyan500',
    'bp-secondary-darkCyan600',
    'bp-secondary-darkCyan700',
    'bp-secondary-darkCyan800',
    'bp-secondary-darkCyan900',
    'bp-secondary-pureOrange50',
    'bp-secondary-pureOrange100',
    'bp-secondary-pureOrange200',
    'bp-secondary-pureOrange300',
    'bp-secondary-pureOrange400',
    'bp-secondary-pureOrange500',
    'bp-secondary-pureOrange600',
    'bp-secondary-pureOrange700',
    'bp-secondary-pureOrange800',
    'bp-secondary-pureOrange900',
    'bp-secondary-purple50',
    'bp-secondary-purple100',
    'bp-secondary-purple200',
    'bp-secondary-purple300',
    'bp-secondary-purple400',
    'bp-secondary-purple500',
    'bp-secondary-purple600',
    'bp-secondary-purple700',
    'bp-secondary-purple800',
    'bp-secondary-purple900',
    'bp-secondary-darkGrayishBlue50',
    'bp-secondary-darkGrayishBlue100',
    'bp-secondary-darkGrayishBlue200',
    'bp-secondary-darkGrayishBlue300',
    'bp-secondary-darkGrayishBlue400',
    'bp-secondary-darkGrayishBlue500',
    'bp-secondary-darkGrayishBlue600',
    'bp-secondary-darkGrayishBlue700',
    'bp-secondary-darkGrayishBlue800',
    'bp-secondary-darkGrayishBlue900',
    'bp-grayScaleWhite',
    'bp-grayScale50',
    'bp-grayScale100',
    'bp-grayScale200',
    'bp-grayScale300',
    'bp-grayScale400',
    'bp-grayScale500',
    'bp-alert-success50',
    'bp-alert-success100',
    'bp-alert-success200',
    'bp-alert-success300',
    'bp-alert-success400',
    'bp-alert-success500',
    'bp-alert-success600',
    'bp-alert-success700',
    'bp-alert-success800',
    'bp-alert-success900',
    'bp-alert-information50',
    'bp-alert-information100',
    'bp-alert-information200',
    'bp-alert-information300',
    'bp-alert-information400',
    'bp-alert-information500',
    'bp-alert-information600',
    'bp-alert-information700',
    'bp-alert-information800',
    'bp-alert-information900',
    'bp-alert-warning50',
    'bp-alert-warning100',
    'bp-alert-warning200',
    'bp-alert-warning300',
    'bp-alert-warning400',
    'bp-alert-warning500',
    'bp-alert-warning600',
    'bp-alert-warning700',
    'bp-alert-warning800',
    'bp-alert-warning900',
    'bp-alert-error50',
    'bp-alert-error100',
    'bp-alert-error200',
    'bp-alert-error300',
    'bp-alert-error400',
    'bp-alert-error500',
    'bp-alert-error600',
    'bp-alert-error700',
    'bp-alert-error800',
    'bp-alert-error900',
    'bp-overlayWhite',
    'bp-overlayDark',
    'bp-skeleton-lightModeStart',
    'bp-skeleton-lightModeEnd',
    'inherit'
];

const isValidColor = (colorValue) => {
    return ALL_COLORS.includes(colorValue);
};

const iconCss = "@font-face{font-family:'Material Icons';font-style:normal;font-weight:400;src:local('Material Icons'),\n    url(https://fonts.gstatic.com/s/materialicons/v140/flUhRq6tzZclQEJ-Vdg-IuiaDsNcIhQ8tQ.woff2)\n      format('woff2')}@font-face{font-family:'Material Icons Outlined';font-style:normal;font-weight:400;src:local('Material Icons Outlined'),\n    url(https://fonts.gstatic.com/s/materialiconsoutlined/v109/gok-H7zzDkdnRel8-DQ6KAXJ69wP1tGnf4ZGhUcel5euIg.woff2)\n      format('woff2')}@font-face{font-family:'Material Icons Round';font-style:normal;font-weight:400;src:local('Material Icons Round'),\n    url(https://fonts.gstatic.com/s/materialiconsround/v108/LDItaoyNOAY6Uewc665JcIzCKsKc_M9flwmPq_HTTw.woff2)\n      format('woff2')}@font-face{font-family:'Material Icons Sharp';font-style:normal;font-weight:400;src:local('Material Icons Sharp'),\n    url(https://fonts.gstatic.com/s/materialiconssharp/v109/oPWQ_lt5nv4pWNJpghLP75WiFR4kLh3kvmvRImcycg.woff2)\n      format('woff2')}@font-face{font-family:'Material Icons Two Tone';font-style:normal;font-weight:400;src:local('Material Icons Two Tone'),\n    url(https://fonts.gstatic.com/s/materialiconstwotone/v112/hESh6WRmNCxEqUmNyh3JDeGxjVVyMg4tHGctNCu0NjbrHg.woff2)\n      format('woff2')}:host{display:inline-block}:host,:host *{-webkit-box-sizing:border-box;box-sizing:border-box}.icon{font-family:\"Material Icons\", sans-serif;font-weight:normal;font-style:normal;font-size:24px;line-height:1;letter-spacing:normal;text-transform:none;display:block;white-space:nowrap;word-wrap:normal;direction:ltr;font-feature-settings:\"liga\";-webkit-font-feature-settings:\"liga\";-webkit-font-smoothing:antialiased}";
const PichinchaIconStyle0 = iconCss;

const Icon = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.customColorValue = undefined;
        this.cssColorValue = undefined;
        this.type = 'outlined';
        this.size = '24px';
        this.preloadedStyles = [];
    }
    get computedColor() {
        switch (true) {
            case this.customColorValue && isValidColor(this.customColorValue):
                return `var(--${this.customColorValue})`;
            case this.cssColorValue !== undefined && this.cssColorValue !== '':
                return this.cssColorValue;
            default:
                return 'inherited';
        }
    }
    render() {
        const fontFamilies = {
            filled: 'Material Icons',
            outlined: 'Material Icons Outlined',
            round: 'Material Icons Round',
            sharp: 'Material Icons Sharp',
            'two-tone': 'Material Icons Two Tone',
        };
        const selectedType = fontFamilies.hasOwnProperty(this.type)
            ? this.type
            : 'outlined';
        const fontFamily = fontFamilies[selectedType];
        const stylesSum = {
            fontFamily: fontFamily,
            fontSize: this.size,
            color: this.computedColor,
            width: this.size,
            height: this.size,
            textAlign: 'center',
        };
        return (h(Host, { key: '6f89aa78d9e2c1824f6f18b1f6e98739669ccc65', style: { width: this.size, height: this.size } }, h("i", { key: '540cd47ba80749d8cf4e6191717998e82d696f89', style: stylesSum, class: "icon" }, h("slot", { key: 'a16ecf7c7e9b32e97497ef88219400fa346ec697' }))));
    }
    static get assetsDirs() { return ["pichincha-icons"]; }
};
Icon.style = PichinchaIconStyle0;

const typographyCss = "@font-face{font-family:'preloslab-book';src:local('preloslab-book'),\n    url('https://cdn.pichincha.com/v0.0.3-statics/wc-design-pichincha/statics/preloslab-book.woff2')\n      format('woff2');font-style:normal}@font-face{font-family:'preloslab-semibold';src:local('preloslab-semibold'),\n    url('https://cdn.pichincha.com/v0.0.3-statics/wc-design-pichincha/statics/preloslab-semibold.woff2')\n      format('woff2');font-style:normal}@font-face{font-family:'prelo-medium';src:local('prelo-medium'),\n    url('https://cdn.pichincha.com/v0.0.3-statics/wc-design-pichincha/statics/prelo-medium.woff2')\n      format('woff2');font-style:normal}@font-face{font-family:'prelo-bold';src:local('prelo-bold'),\n    url('https://cdn.pichincha.com/v0.0.3-statics/wc-design-pichincha/statics/prelo-bold.woff2')\n      format('woff2');font-style:normal}@font-face{font-family:'prelo-semibold';src:local('prelo-bold'),\n    url('https://cdn.pichincha.com/v0.0.3-statics/wc-design-pichincha/statics/prelo-semibold.woff2')\n      format('woff2');font-style:normal}@font-face{font-family:'prelo-book';src:local('prelo-book'),\n    url('https://cdn.pichincha.com/v0.0.3-statics/wc-design-pichincha/statics/prelo-book.woff2')\n      format('woff2');font-style:normal}.typography{width:100%;margin:0;padding:0}.typography__prelo--weight-100,.typography__prelo--weight-200,.typography__prelo--weight-300,.typography__prelo--weight-400{font-family:prelo-book, Helvetica, Arial, Sans, Sans-serif}.typography__prelo--weight-500{font-family:prelo-medium, Helvetica, Arial, Sans, Sans-serif}.typography__prelo--weight-600,.typography__prelo--weight-700{font-family:prelo-semibold, Helvetica, Arial, Sans, Sans-serif}.typography__prelo--weight-800,.typography__prelo--weight-900{font-family:prelo-bold, Helvetica, Arial, Sans, Sans-serif}.typography__prelo-slab--weight-100,.typography__prelo-slab--weight-200,.typography__prelo-slab--weight-300,.typography__prelo-slab--weight-400,.typography__prelo-slab--weight-500{font-family:preloslab-book, Helvetica, Arial, Sans, Sans-serif}.typography__prelo-slab--weight-600,.typography__prelo-slab--weight-700,.typography__prelo-slab--weight-800,.typography__prelo-slab--weight-900{font-family:preloslab-semibold, Helvetica, Arial, Sans, Sans-serif}";
const PichinchaTypographyStyle0 = typographyCss;

const Typography = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.renderTag = () => {
            const ellipsisStyles = this.isEllipsis
                ? { whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }
                : {};
            const styles = Object.assign({ color: this.color ? `var(--${this.color})` : 'inherit', fontSize: this.size, lineHeight: this.lineHeight, textAlign: this.align, letterSpacing: `${this.spacing}px`, textDecoration: this.decoration, fontWeight: 'unset', marginBlock: 'unset', marginInline: 'unset' }, ellipsisStyles);
            const ariaHidden = Object.assign({}, (this.isAriaHidden ? { 'aria-hidden': 'true' } : {}));
            switch (this.category) {
                case 'h1':
                    return (h("h1", Object.assign({ role: "heading", "aria-level": "1", class: this.getTypographyClass(), style: styles, tabIndex: this.tabIndexElement }, ariaHidden), h("slot", null)));
                case 'h2':
                    return (h("h2", Object.assign({ role: "heading", "aria-level": "2", class: this.getTypographyClass(), style: styles, tabIndex: this.tabIndexElement }, ariaHidden), h("slot", null)));
                case 'h3':
                    return (h("h3", Object.assign({ role: "heading", "aria-level": "3", class: this.getTypographyClass(), style: styles, tabIndex: this.tabIndexElement }, ariaHidden), h("slot", null)));
                default:
                    return (h("p", Object.assign({ role: "text", class: this.getTypographyClass(), style: styles, tabIndex: this.tabIndexElement }, ariaHidden), h("slot", null)));
            }
        };
        this.variant = 'prelo-slab';
        this.category = undefined;
        this.color = undefined;
        this.weight = '500';
        this.align = 'inherit';
        this.size = '16px';
        this.lineHeight = '24px';
        this.spacing = 0;
        this.isEllipsis = false;
        this.decoration = 'none';
        this.tabIndexElement = 0;
        this.isAriaHidden = false;
    }
    getTypographyClass() {
        const baseClass = 'typography';
        return classNames({
            [baseClass]: true,
            [`${baseClass}__${this.variant}--weight-${this.weight}`]: true,
        });
    }
    render() {
        return h(Host, { key: 'ded57870f6d3ff40f56bde7f39316b83d06b145c' }, this.renderTag());
    }
    static get assetsDirs() { return ["pichincha-fonts"]; }
};
Typography.style = PichinchaTypographyStyle0;

export { Icon as pichincha_icon, Typography as pichincha_typography };
